import Vue from 'vue';
import './alert';

Vue.component('LanguageToggle', () => import('./LanguageToggle.vue'));
Vue.component('ClickAndDrag', () => import('./ClickAndDrag.vue'));
Vue.component('FormModal', () => import('./FormModal.vue'));
Vue.component('WYSIWYG', () => import('./WYSIWYG.vue'));
Vue.component('AddressInput', () => import('./AddressInput.vue'));
Vue.component('ContactInfoDisplay', () => import('../deployment/ContactInfoDisplay.vue'));
